import { OrderType } from "../../../utils/homologar/search/utils/constants";

export const defaultOrderTypesConfig = [
  {
    label: "Estudio por imágenes",
    value: OrderType.IMAGING,
    order: 1,
    disabled: false,
    maxItemsPerOrder: 1,
  },
  {
    label: "Laboratorio",
    value: OrderType.LABORATORY,
    order: 2,
    disabled: false,
    maxItemsPerOrder: null,
  },
  {
    label: "Otros",
    value: OrderType.MANUAL,
    order: 3,
    disabled: false,
    maxItemsPerOrder: null,
  },
];

export const practicesOrderTypesConfig = [
  {
    label: "Prácticas",
    value: OrderType.PRACTICES,
    order: 1,
    disabled: false,
    maxItemsPerOrder: null,
  },
  {
    label: "Otros",
    value: OrderType.MANUAL,
    order: 2,
    disabled: false,
    maxItemsPerOrder: null,
  },
];
